import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import issueImage from "../../../../src/collections/blog/2019/2019-12-04-layer5-landscape-spectrums-revisited/issue.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  issueImage,
  React
};